<template>
  <v-card outlined class="full-height">
    <div
      v-if="modelValue.Website && modelValue.Website.url"
      class="d-flex justify-center align-center ma-4"
      style="position: relative; height: 200px"
    >
      <iframe class="website-preview" :src="`${modelValue.Website.url}`" />
    </div>

    <v-card-text>
      <v-card class="elevation-0">
        <v-card-title class="text-overline pa-0 ma-0">
          Budget

          <div class="text-primary text-h3 font-weight-bold">90%</div>

          <div class="text-h6 text-medium-emphasis font-weight-regular">
            2,530 Ads
          </div>
        </v-card-title>
        <br />

        <v-card-text class="pa-0 ma-0">
          <div
            :style="`right: calc(${review} + 8px)`"
            class="position-absolute mt-n8 text-caption text-primary"
          >
            Spent
          </div>
          <v-progress-linear
            color="primary"
            height="22"
            model-value="90"
            rounded="lg"
          >
            <v-badge
              :style="`right: ${review}`"
              class="position-absolute"
              color="white"
              dot
              inline
            ></v-badge>
          </v-progress-linear>

          <div class="d-flex justify-space-between py-3">
            <span class="text-primary font-weight-medium"> 2,530 Ads </span>

            <span class="text-medium-emphasis"> 330 left </span>
          </div>
        </v-card-text>

        <v-card-title class="text-overline pa-0 ma-0"> Progress </v-card-title>
        <v-card-text class="pa-0 ma-0 mt-6">
          <div v-for="goal in modelValue.Goals" :key="goal.id">
            <div class="text-caption">{{ goal.KPI.name }} {{ goal.value }}</div>
            <v-slider
              :color="
                getProgressValue(goal)?.value / goal.value > 0.8
                  ? 'success'
                  : getProgressValue(goal)?.value / goal.value > 0.25
                  ? 'primary'
                  : 'error'
              "
              :model-value="getProgressValue(goal)?.value"
              :max="
                getProgressValue(goal) && goal.value < getProgressValue(goal)
                  ? goal.value
                  : getProgressValue(goal)?.value
              "
              :min="0"
              readonly
              hide-details
              thumb-label="always"
              class="px-4"
            />
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <!-- <v-list-item
          append-icon="mdi-chevron-right"
          lines="two"
          subtitle="Details and agreement"
          link
        ></v-list-item> -->
      </v-card>
    </v-card-text>

    <v-card-text>
      <v-chip-group selected-class="text-primary" column>
        <v-chip v-for="tag in Audience" :key="tag">
          {{ tag.name }}
        </v-chip>
      </v-chip-group>
    </v-card-text>

    <v-card-actions class="card-actions-bottom">
      <v-btn outlined text @click="() => $emit('onDetails', modelValue)">
        View Details
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
    
    
  <script>
import { CampaignAPIInstance } from "@/api";
import moment from "moment";

export default {
  components: {},
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      review: "10%",
      goalsProgress: [],
    };
  },
  computed: {
    Audience() {
      return this.modelValue && this.modelValue.Targeting
        ? [
            ...this.modelValue.Targeting.Countries.map(
              (audience) => audience.Country
            ),
            ...this.modelValue.Targeting.Ages.map(
              (audience) => audience.Category
            ),
            ...this.modelValue.Targeting.Genders.map(
              (audience) => audience.Category
            ),
            ...this.modelValue.Targeting.Interests.map(
              (audience) => audience.Category
            ),
            ...this.modelValue.Targeting.Channels.map(
              (audience) => audience.Channel
            ),
          ]
        : [];
    },
  },
  watch: {
    modelValue: {
      handler() {
        this.getGoalsProgress();
      },
      deep: true,
    },
  },
  created() {
    this.getGoalsProgress();
  },

  methods: {
    formatDates(date) {
      return moment(date).format("MMMM Do");
    },
    getProgressValue(goal) {
      if (!this.modelValue.Goals) return;

      const found = this.goalsProgress.find(
        (progress) => progress.KPI.code === goal.KPI.code
      );

      return found;
    },
    async getGoalsProgress() {
      if (!this.modelValue.Goals) return;

      const { data } = await CampaignAPIInstance.Analytics.goalsProgress(
        this.modelValue.id,
        [...this.modelValue.Goals.map((goal) => goal.KPI.code)]
      );
      this.goalsProgress = data;
    },
  },
};
</script>
    
    

<style lang="scss" scoped>
.website-preview {
  transform: scale(calc(100% / 4));
  transform-origin: top left;
  width: calc(100% * 4);
  height: 800px;
  border: none;
  position: absolute;
  left: 0;
  top: 0;
}
</style>